import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
import { useSubmitField } from '../../hooks/useSubmitField';
import { withConditionalField } from '../../hoc/withConditionalField';
import ButtonFieldLayout from '../../layouts/common/ButtonFieldLayout';

interface Props {
  className?: string;
}

const NotifyWatchersField: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('notifyWatchers', {
    submitAdapter: ({ notifyWatchers }) => ({
      notify_watchers: notifyWatchers,
    }),
  });

  return (
    <ButtonFieldLayout
      label={t('deviationSubmit.form.notifyWatchers.label')}
      labelProps={{ id: `${id}-label`, htmlFor: id }}
    >
      <MainToggle
        variant="main"
        id={id}
        size={isMobile ? 'large' : 'small'}
        value={value}
        onChange={onChange}
        aria-labelledby={`${id}-label`}
      />
    </ButtonFieldLayout>
  );
};
NotifyWatchersField.displayName = 'NotifyWatchersField';

// Field only renders on edit forms
export default withConditionalField<Props>(
  NotifyWatchersField,
  ({ isEdit }) => isEdit ?? false
);
